const css = `.IIsmMa__wrapper[data-visible=false]{visibility:hidden}.IIsmMa__text{white-space:pre-line}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"text":"IIsmMa__text","wrapper":"IIsmMa__wrapper"};
